import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '@/lib/api';
import { Sparkles, ChevronRight } from 'lucide-react';

/** SoulEnrichmentTile — compact strip showing pending soul-fact
 *  suggestions across all programmes. Links to the review page. */
export default function SoulEnrichmentTile({ className = '' }) {
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/soul-enrichment/pending?limit=1')
      .then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;
  const byClient = Object.entries(data.pending_by_client || {});

  return (
    <button
      onClick={() => navigate('/soul-enrichment')}
      className={`w-full text-left rounded-xl border border-[#e2d8c8] bg-[#FBF7EF] px-5 py-3.5 hover:bg-[#f6efe2] transition-colors ${className}`}
      data-testid="soul-enrichment-tile"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <Sparkles size={17} color="#7A5C2B" />
          <span className="font-semibold text-[14px] text-[#3B3528]">
            Soul Enrichment Loop
          </span>
          <span
            className="text-[12px] px-2 py-0.5 rounded-full bg-[#1B2A4A] text-white font-semibold"
            data-testid="soul-enrichment-pending-count"
          >
            {data.total_pending} pending
          </span>
          {byClient.length > 0 && (
            <span className="text-[12px] text-[#6B5439]">
              {byClient.map(([c, n]) => `${c} ${n}`).join(' · ')}
            </span>
          )}
        </div>
        <span className="flex items-center gap-0.5 text-[12px] font-semibold text-[#7A5C2B]">
          Review <ChevronRight size={14} />
        </span>
      </div>
    </button>
  );
}
